module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 16l7-7 7 7-7 7z\"></path></svg>"